import "./App.css";
import { useState } from "react";
import { AnswerGrid, Submit } from "./components/inputs";
import { ProgressBar } from "./components/ProgressBar/progressBar";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {
  BrowserRouter,
  Route,
  Routes,
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";

function Form() {
  const location = useLocation();
  const navigate = useNavigate();
  const [flowSelected, setFlowSelected] = useState(0);
  const [percent, setPercent] = useState(0);
  const [flows, setFlows] = useState([
    {
      qid: 1,
      headtitle: "Do you currently accept card payments?",
      type: "GRID",
      path: "/",
      answers: [
        {
          title: "Yes",
          icon_url: "",
          selected: true,
        },
        {
          title: "No",
          icon_url: "",
          selected: false,
        },
      ],
    },
    {
      qid: 2,
      headtitle: "Who is your current provider?",
      type: "LIST",
      path: "current-provider",
      answers: [
        {
          title: "AIB",
          icon_url: "",
          selected: true,
        },
        {
          title: "Sumup",
          icon_url: "",
          selected: false,
        },
        {
          title: "Worldpay",
          icon_url: "",
          selected: false,
        },
        {
          title: "Elavon",
          icon_url: "",
          selected: false,
        },
        {
          title: "Payment Plus IE",
          icon_url: "",
          selected: false,
        },
        {
          title: "Bank of Ireland (EVO)",
          icon_url: "",
          selected: false,
        },
        {
          title: "Others / Prefer not to say",
          icon_url: "",
          selected: false,
        },
      ],
    },
    {
      qid: 3,
      headtitle: "What industry are you in?",
      type: "GRID",
      path: "industry",
      answers: [
        {
          title: "Restaurant",
          icon_url: "https://npi.ie/wp-content/uploads/2022/09/Restaurant.png",
          selected: true,
        },
        {
          title: "Self Employed",
          icon_url:
            "https://npi.ie/wp-content/uploads/2022/09/SELF-EMPLOYED.png",
          selected: false,
        },
        {
          title: "Bar & Pubs",
          icon_url: "https://npi.ie/wp-content/uploads/2022/09/Pint.png",
          selected: false,
        },
        {
          title: "Coffee Shop",
          icon_url: "https://npi.ie/wp-content/uploads/2022/09/Cafe.png",
          selected: false,
        },
        {
          title: "Nightclub",
          icon_url: "https://npi.ie/wp-content/uploads/2022/09/Nightclubs.png",
          selected: false,
        },
        {
          title: "Retail",
          icon_url: "https://npi.ie/wp-content/uploads/2022/09/Retail.png",
          selected: false,
        },
        {
          title: "Events and Festivals",
          icon_url: "https://npi.ie/wp-content/uploads/2022/09/Festival.png",
          selected: false,
        },
        {
          title: "Others",
          icon_url: "https://npi.ie/wp-content/uploads/2022/09/OTHERS.png",
          selected: false,
        },
      ],
    },
    {
      qid: 4,
      headtitle: "How do you want to accept payments?",
      type: "LIST",
      path: "accept-payments",
      answers: [
        {
          title: "Face to Face",
          icon_url: "",
          selected: true,
        },
        {
          title: "Online or over the phone",
          icon_url: "",
          selected: false,
        },
        {
          title: "Both of the above",
          icon_url: "",
          selected: false,
        },
      ],
    },
    {
      qid: 5,
      headtitle: "How much do you expect to make by card per month?",
      type: "LIST",
      path: "expect-per-month",
      answers: [
        {
          title: "Under €1,000",
          icon_url: "",
          selected: true,
        },
        {
          title: "€1,000 - €10,000",
          icon_url: "",
          selected: false,
        },
        {
          title: "€10,000 - €20,000",
          icon_url: "",
          selected: false,
        },
        {
          title: "20,000 - €50,000",
          icon_url: "",
          selected: false,
        },
        {
          title: "50,000 - €100,000",
          icon_url: "",
          selected: false,
        },
        {
          title: "Over €100,000",
          icon_url: "",
          selected: false,
        },
        {
          title: "Unsure / Prefer not to say",
          icon_url: "",
          selected: false,
        },
      ],
    },
    {
      qid: 6,
      headtitle: "Almost done.",
      type: "SUBMIT_SCREEN",
      path: "submit",
      submit_btn_title: "Get Quote",
      fills: [
        {
          id: "name",
          name: "name",
          placeholder: "Name",
          type: "text",
        },
        {
          id: "email_address",
          name: "email_address",
          placeholder: "Email Address",
          type: "email",
        },
        {
          id: "phone_number",
          name: "phone_number",
          placeholder: "Phone Number",
          type: "text",
        },
      ],
    },
  ]);

  const handleFlow = (xQuestion, goNext) => {
    let position = goNext
      ? flowSelected === flows.length - 1
        ? flowSelected
        : flowSelected + 1
      : flowSelected - 1;
    if (flowSelected === 0 && xQuestion === 1) position++;
    if (flowSelected === 2 && !goNext) position--;
    if (goNext) {
      let updatedAnswer = flows[flowSelected].answers.map((a, i) => ({
        ...a,
        selected: xQuestion === i ? true : false,
      }));
      let updatedFlow = [...flows];
      updatedFlow[flowSelected].answers = updatedAnswer;

      setFlows(updatedFlow);
    }
    setFlowSelected(position);

    setPercent(position / flows.length);
    setTimeout(() => {
      navigate(flows[position].path);
    }, 650);
  };

  const handleForm = async (event, setStatusForm) => {
    event.preventDefault();
    setStatusForm({
      log: "Processing...",
      processing: true,
      sended: false,
    });
    const formData = {};
    Array.from(event.currentTarget.elements).forEach((field) => {
      if (!field.name) return;
      formData[field.name] = field.value;
    });

    let finalUserInfo = JSON.stringify(treatUserInfo(formData));
    console.log(finalUserInfo);
    fetch("https://npi.ie/wp-json/npimail/v1/send", {
      method: "post",
      body: finalUserInfo,
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      console.log(response);
      if (response.ok) {
        setStatusForm({
          log: "Message sent",
          processing: false,
          sended: true,
        });
        setPercent(1);
        event.target.reset();
      } else {
        setStatusForm({
          log: "There is a problem with our servers, try again later.",
          processing: false,
          sended: false,
        });
        console.log(response.error);
      }
    });
  };

  const treatUserInfo = (contactInfo) => {
    let userAnswers = [];
    let _flows = [...flows];
    if (_flows[0].answers[1].selected === true) {
      _flows.splice(1, 1);
    }

    _flows.forEach((flow) => {
      if (flow.type !== "SUBMIT_SCREEN") {
        let ans = {
          question: flow.headtitle,
        };
        flow.answers.forEach((a) => {
          if (a.selected) ans.answer = a.title;
        });
        userAnswers.push(ans);
      }
    });
    return {
      ...contactInfo,
      questions: userAnswers,
    };
  };

  return (
    <div className="mainContainer">
      <div className="formContainer">
        <ProgressBar
          percent={percent}
          status={`${(percent * 100).toFixed()}%`}
        />

        <TransitionGroup component={null}>
          <CSSTransition key={location.key} classNames="slide" timeout={800}>
            <Routes location={location}>
              {flows.map((flow, i) => (
                <Route
                  key={i}
                  path={flow.path}
                  element={
                    <PrintFlow
                      flow={flows[i]}
                      onClickAnswer={(i) => handleFlow(i, true)}
                      handleForm={handleForm}
                    />
                  }
                />
              ))}
            </Routes>
          </CSSTransition>
        </TransitionGroup>
        {flowSelected > 0 && flowSelected < flows.length && (
          <div onClick={() => handleFlow(false, false)} className="goBackBtn">
            <label>Go Back</label>
          </div>
        )}
      </div>
    </div>
  );
}

function PrintFlow({ flow, onClickAnswer, handleForm }) {
  if (flow.type === "SUBMIT_SCREEN") {
    return <Submit {...flow} handleForm={handleForm} />;
  } else {
    return (
      <div className="flow">
        <label className="headtitle">{flow.headtitle}</label>
        {flow.answers.map((answer, index) => {
          return (
            <AnswerGrid
              {...answer}
              onClick={() => onClickAnswer(index)}
              key={index + flow.qid}
            />
          );
        })}
      </div>
    );
  }
}
const App = () => (
  <BrowserRouter basename="/get-quote">
    <Form />
  </BrowserRouter>
);
export default App;
